import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, forkJoin } from 'rxjs';

import { ParticipantService } from '../../services/participant.service';
import {
  loadSession,
  loadSessionSuccess,
  loadSessionFailure,
} from '../actions/session.actions';
import { SigningService } from '../../services/signing.service';

@Injectable()
export class SessionEffects {
  private readonly actions$ = inject(Actions);
  private readonly participantService = inject(ParticipantService);
  private readonly signingService = inject(SigningService);

  loadSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSession),
      switchMap(({ participantId }) =>
        forkJoin({
          participant: this.participantService.getById(participantId),
          signing: this.signingService.getByParticipantId(participantId),
        }).pipe(
          map(({ participant, signing }) =>
            loadSessionSuccess({ participant, signing }),
          ),
          catchError((error) => {
            return of(loadSessionFailure({ error: error.message || 'Failed to load session' }));
          }),
        ),
      ),
    ),
  );
}
